import { render, staticRenderFns } from "./FeatureRequestButton.vue?vue&type=template&id=5ad12d5e&scoped=true"
import script from "./FeatureRequestButton.vue?vue&type=script&lang=js"
export * from "./FeatureRequestButton.vue?vue&type=script&lang=js"
import style0 from "./FeatureRequestButton.vue?vue&type=style&index=0&id=5ad12d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad12d5e",
  null
  
)

export default component.exports